<template>
  <div class="froala-container">
    <div class="top-nav-container container">
      <div class="top-nav-controls">
        <NuxtLink class="top-nav-control-url" to="/new-now">
          New + Now
          <FontAwesomeIcon icon="fas fa-angle-right" class="chevron-icon" />
        </NuxtLink>
        <NuxtLink
          class="top-nav-control-url"
          v-for="(url, index) in postDetails.categories"
          :key="index"
          :to="url.path"
        >
          {{ url.name
          }}<span
            class="pipe-separator"
            v-if="index + 1 < postDetails.categories.length"
            >|</span
          >
        </NuxtLink>
        <span class="publish-date">
          <FontAwesomeIcon icon="fas fa-angle-right" class="chevron-icon" />
          {{ dayjs(postDetails.publish_date).format("MMM DD, YYYY") }}
        </span>
      </div>

      <div class="share-container">
        <SocialShareBar />
      </div>
    </div>

    <h2 class="blog-post-header">
      {{ postDetails.title }}
    </h2>

    <div v-html="html" class="froala-content m4-5"></div>

    <div class="footer-categories">
      <span>Categories: </span>
      <NuxtLink 
        v-for="(url, idx) in postDetails.categories" 
        :key="idx"
        :to="url.path"
      >
        {{ url.name }}<span v-if="idx+1 < postDetails.categories.length">, </span>
      </NuxtLink>
      
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { ref, computed, onMounted } from "vue";
import dayjs from "dayjs";
// import localizedFormat from 'dayjs/plugin/localizedFormat'
// import customParseFormat from 'dayjs/plugin/customParseFormat'

const { isDesktop } = useMobileChecker();
const { posts, categories, loadPosts } = useBlogPosts("Main");

const route = useRoute();

// PROPS
const props = defineProps(["html", "postDetails"]);
const categorySlug = route.params.category;

onMounted(async () => {
  await loadPosts();

  const category = categories.value.find(
    (c) => useLowerCase(c.slug) === useLowerCase(categorySlug)
  );
  if (category) categoryName.value = category.name;
});
</script>

<style lang="scss" scoped>
/* optional: style your froala bootstrap design blocks */
/* .froala-content {
  max-width: 720px;
  margin: 0 auto;
} */

.froala-container {
  padding: 20px;

  .top-nav-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    .top-nav-controls {
      margin: 10px 0 15px 0px;

      a {
        text-decoration: none;
        color: $black;
      }

      .top-nav-control-url,
      span {
        font-family: $font_poppin_bold;
        text-transform: uppercase;
        font-size: 10px;
        line-height: 10px;
        letter-spacing: 1px;
      }

      .pipe-separator {
        padding: 0 3px;
      }

      .chevron-icon {
        height: 6px;
        font-family: $font_didot_bold;
        vertical-align: middle;
        font-weight: 900;
        margin-right: 4px;
        stroke: currentColor;
        stroke-width: 80; // MAKES BOLDER
        width: 4px;
      }

      .publish-date {
        .chevron-icon {
          margin-left: 4px;
        }
      }
    }

    @media only screen and (max-width: 1024px) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin: 15px 0;

      .top-nav-controls,
      .share-container {
        margin: 0px 0 5px 0px;
      }

    }

    @media only screen and (max-width: 580px) {
      padding-right: 5px;
      padding-left: 5px;

      .top-nav-controls {
        .top-nav-control-url,
        span {
          letter-spacing: 0.75px;
        }
      }
    }
  }

  .share-container {
    margin: 10px 0 15px 0px;
    font-family: $font_poppin_bold;
    text-transform: uppercase;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: 1px;
  }

  .blog-post-header {
    font-family: $font_didot_roman;
    font-size: 52px !important;
    letter-spacing: -4px !important;
    font-style: italic !important;
    padding: 0 0 20px 0 !important;
    border-bottom: none !important;
    line-height: 52px !important;
    text-transform: uppercase;
    margin-top: 10px;
    display: inline-block;
    margin-bottom: 0;


    @media only screen and (max-width: 1024px) {
      font-size: 40px !important;
      letter-spacing: -2px !important;
      line-height: 44px !important;
      padding: 0 0 20px 10px !important;
    }

    @media only screen and (max-width: 768px) {
      font-size: 38px !important;
      line-height: 42px !important;
    }

    @media only screen and (max-width: 580px) {
      font-size: 36px !important;
      line-height: 40px !important;
      padding: 0 0 20px 0px !important;
    }
  }

  .footer-categories {
    font-family: $font_poppin_bold;
    font-size: 10px;
    line-height: 10px;
    text-transform: uppercase;
    margin: 15px 0 15px 0;
    padding-bottom: 15px;
    letter-spacing: 1px;
    clear: both;
    display: block;
    text-align: right;
    border-bottom: 1px solid $black;
    a {
      text-decoration: none;
      color: $black;
    }
  }

  @media only screen and (max-width: 580px) {
    padding: 20px 0;
  }
}
</style>
